import React, { useState, useContext, useEffect } from 'react';

import '../../../styles/pages/crm/deal.scss';
import EditablePipelineStage from '../shared/field_inputs/EditablePipelineStage';
import EditablePipelineAndStage from '../shared/field_inputs/EditablePipelineAndStage';
import { DataContext as SharedDataContext } from '../../../stores/crm-store';
import SpinLoader from '../shared/field_inputs/shared/SpinLoader';
import { DataContext } from '../../../../src/stores/crm-deal-store';

/**
 * Row 1: Big pipeline bar with each stage that changes stage onclick.
 * Row 2: Editable "Line > Stage".
 * - `Pipeline`: `{string id, string name, int order, list<PipelineStage> pipelineStages}`
 * - `PipelineStage`: `{string id, string pipelineId, string name, int order}`
 * @param {object} [pipeline] Initial deal-pipeline.
 * @param {object} [pipelineStage] Initial deal-pipelineStage.
 * @param {bool} [dealStatus] Null - open. True - won. False - lost.
 * @param {function} [handleSave] [async {Pipeline pipeline, PipelineStage pipelineStage}=>{bool success, string message}] Save changes / return error message.
 */
const PipelineSummary = ({ initialPipelineStage, dealStatus, handleSave: syncChanges, updateStore }) => {
    const { store } = useContext(SharedDataContext);
    const { pipelineOptions: pipelines } = store;
    const [pipeline, setPipeline] = useState(undefined);
    const [pipelineStage, setPipelineStage] = useState(initialPipelineStage);

    const {
        store: { activeDeal },
        dispatch,
    } = useContext(DataContext);

    useEffect(() => {
        if ( initialPipelineStage ) {
            setPipelineStage(initialPipelineStage);
        }
    }, [initialPipelineStage]);

    useEffect(() => {
        if (pipelines.length && pipelineStage) {
            setPipeline(pipelines.find((p) => p.pipelineStages.some((s) => s.id === pipelineStage.id)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pipelines, pipelineStage]);

    if (!store.areSelectOptionsFetched || !pipelines || !pipeline) {
        return (
            <div className='crm-loader-wrapper' style={{ width: '100%', height: '54.5px' }}>
                <SpinLoader isLoading />
            </div>
        );
    }
    const handleSave = async (pipeline, pipelineStage) => {
        const response = await syncChanges({ pipeline, pipelineStage });
        if (response.success) {
            response.deal.pipelineId = pipelineStage.id;
            response.deal.pipelineStage = pipelineStage;
            updateStore(response.deal, activeDeal);
            setPipeline(pipeline);
            setPipelineStage(pipelineStage);
            dispatch({
                type: 'UPDATE_CURRENT_PIPE_STAGE_ID',
                pipelineStageId: pipelineStage.id,
            });
            dispatch({
                type: 'UPDATE_CURRENT_PIPE_ID',
                pipelineId: pipelineStage.pipelineId,
            });
        }
        return response;
    };

    return (
        <div className='deal-pipeline-summary-wrapper'>
            <EditablePipelineStage
                {...{ pipelineStage, dealStatus }}
                pipelineStages={pipeline.pipelineStages}
                pipelineStageHistory={activeDeal.pipelineStageHistory}
                handleSave={(s) => handleSave(pipeline, s)}
                pseudoPostSave
            />
            <EditablePipelineAndStage {...{ pipeline, pipelineStage, pipelines, handleSave }} />
        </div>
    );
};

export default PipelineSummary;
